import type { JSX } from "react";

interface TargetingPreviewProps {
  actionComponent: JSX.Element;
}

export default function TargetingPreview({
  actionComponent,
}: TargetingPreviewProps) {
  return (
    <section className="flex flex-col items-start rounded-3xl border border-black-200 p-3">
      <div className="mb-2 flex w-full justify-between border-b border-black-200 pb-2">
        <div className="flex flex-col gap-y-0.5">
          <h3 className="text-button-md">Targeting</h3>
          <p className="text-xs text-black-500">
            Your targeting configuration for this campaign
          </p>
        </div>
        {actionComponent}
      </div>
      LIST INFORMATION GOES HERE
    </section>
  );
}
